import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AssetModelProperty } from '../../models/AssetModelProperty';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ModelPropertyProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/model-property';

  getModels(): Observable<ApiResponse<AssetModelProperty[]>> {
    return this.httpClient.get<ApiResponse<AssetModelProperty[]>>(`${this.baseUrl}/all`);
  }

  upsertModel(model: AssetModelProperty): Observable<ApiResponse<AssetModelProperty>> {
    return this.httpClient.post<ApiResponse<AssetModelProperty>>(`${this.baseUrl}`, model);
  }

  getMultipleModelProperties(ids: string[]): Observable<ApiResponse<AssetModelProperty[]>> {
    return this.httpClient.post<ApiResponse<AssetModelProperty[]>>(`${this.baseUrl}/by-ids`, ids);
  }
}
